// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  SET_BULK_REMINDER_SUMMARY_EMAIL,
  SET_FILING_STATUS_DATA,
  SET_PCN_DATA,
  SET_PCN_RENEWAL_DATA,
  SET_PCN_RENEWAL_HIGHLIGHTED_IDS,
  SET_RENEWAL_ADMIN_DATA,
  SET_RENEWAL_ADMIN_HIGHLIGHTED_IDS,
  SET_WORK_ORDERS_DATA,
} from './types'

import {
  getPcnRenewalInitialState,
  getPcnRenewalAdminTransactionsInitState,
} from './initialState'

export const setFilingStatusData = data => ({
  type: SET_FILING_STATUS_DATA,
  data,
  dataExpiration: Date.now() + (1000 * 60 * 60 * 24),
})

export const setPcnData = data => ({
  type: SET_PCN_DATA,
  data,
  dataExpiration: Date.now() + (1000 * 60 * 60 * 24),
})

export const setPcnRenewalData = data => ({
  type: SET_PCN_RENEWAL_DATA,
  data,
  dataExpiration: Date.now() + (1000 * 60 * 60 * 24),
})

export const setPcnRenewalHighlightedIds = (newHighlightData = getPcnRenewalInitialState()) => ({
  type: SET_PCN_RENEWAL_HIGHLIGHTED_IDS,
  newHighlightData,
})

export const setPcnRenewalAdminTransactions = data => ({
  type: SET_RENEWAL_ADMIN_DATA,
  data,
  dataExpiration: Date.now() + (1000 * 60 * 60 * 24),
})

export const setRenewalAdminHighlightedIds = (newHighlightData = getPcnRenewalAdminTransactionsInitState()) => ({
  type: SET_RENEWAL_ADMIN_HIGHLIGHTED_IDS,
  newHighlightData,
})

export const setWorkOrdersData = data => ({
  type: SET_WORK_ORDERS_DATA,
  data,
  dataExpiration: Date.now() + (1000 * 60 * 60 * 24),
})

export const setBulkReminderSummaryEmail = (bulkReminderSummaryEmailData = getPcnRenewalInitialState()) => ({
  type: SET_BULK_REMINDER_SUMMARY_EMAIL,
  bulkReminderSummaryEmailData,
})
